module.exports = __webpack_public_path__ + "img/list.0d1c6e18.svg";